import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'components/organisms/player-position-stacking/actions';
import {connect} from 'react-redux';

class RemoveStackItem extends Component {
    removeItem(itemId) {
        this.props.dispatch(Action.do('removeItemOfPlayerPositionStacking', itemId));
    }

    render() {
        const {itemId} = this.props;

        return <span onClick={() => ::this.removeItem(itemId)} className="tag-remove"></span>;
    }
}

export default connect(() => ({}))(RemoveStackItem);
